import React from 'react';
import PropTypes from 'prop-types';

/**
 * BtnUpdate
 */
class BtnUpdate extends React.Component {
  constructor(props) {
    super(props);
    this.click = this.click.bind(this);
  }

  click() {
    if (document.getElementById("search") != null) {
      document.getElementById('search').value = '';
    }

    this.props.actions.clickUpdate();
  }
  render() {
    return (
      <div className="btn_gray" onClick={() => this.click()}>
        リセット
      </div>
    );
  }
}

BtnUpdate.propTypes = {
  actions: PropTypes.any.isRequired
};

export default BtnUpdate;
